import PageLayout from '@/components/layout/PageLayout';
import SeoHead from '@/components/seo/SeoHead';
import FeaturesHero from '@/components/features/FeaturesHero';
import FeatureGrid from '@/components/features/FeatureGrid';
import FeatureCategoriesSection from '@/components/features/FeatureCategoriesSection';
import TrustStrip from '@/components/features/TrustStrip';
import FeaturesFAQ from '@/components/features/FeaturesFAQ';
import FooterCTA from '@/components/features/FooterCTA';

/**
 * FeaturesPage Component
 * Complete features page showcasing Notematic capabilities
 * 
 * Structure:
 * 1. Hero with title, subtitle, CTAs, and disclaimer badge
 * 2. Feature Grid (8 main features)
 * 3. Deep Dive Categories (accordion sections)
 * 4. Trust Strip (compliance indicators)
 * 5. FAQ Section
 * 6. Footer CTA (email capture)
 */
export default function FeaturesPage() {
  return (
    <PageLayout>
      <SeoHead
        title="Features — AI Clinical Documentation Platform for Mental Health | Notematic"
        description="Explore Notematic's features: AI-assisted IAR-DST note generation, triage notes, secure transcription, clinician review controls, audit trail, and governance-first design for Australian mental health services."
        canonical="/features"
      />
      <FeaturesHero />
      <FeatureGrid />
      <FeatureCategoriesSection />
      <TrustStrip />
      <FeaturesFAQ />
      <FooterCTA />
    </PageLayout>
  );
}

